/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_StudioInputs */

const en_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const es_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudio`)
};

const fr_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const de_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const ja_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタジオ`)
};

const zh_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作室`)
};

const ar_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استوديو`)
};

const id_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const it_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio`)
};

const ru_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Студия`)
};

const pt_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estúdio`)
};

const ko_val_studio = /** @type {(inputs: Val_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스튜디오`)
};

/**
* | output |
* | --- |
* | "Studio" |
*
* @param {Val_StudioInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_studio = /** @type {((inputs?: Val_StudioInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_StudioInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_studio(inputs)
	if (locale === "es") return es_val_studio(inputs)
	if (locale === "fr") return fr_val_studio(inputs)
	if (locale === "de") return de_val_studio(inputs)
	if (locale === "ja") return ja_val_studio(inputs)
	if (locale === "zh") return zh_val_studio(inputs)
	if (locale === "ar") return ar_val_studio(inputs)
	if (locale === "id") return id_val_studio(inputs)
	if (locale === "it") return it_val_studio(inputs)
	if (locale === "ru") return ru_val_studio(inputs)
	if (locale === "pt") return pt_val_studio(inputs)
	return ko_val_studio(inputs)
});